// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var $$String = require("rescript/lib/js/string.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Belt_Int = require("rescript/lib/js/belt_Int.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_format = require("rescript/lib/js/caml_format.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Querystringify = require("querystringify");
var JsxRuntime = require("react/jsx-runtime");
var RescriptReactRouter = require("@rescript/react/src/RescriptReactRouter.res.js");
var Http$ReactHooksTemplate = require("./common/http.res.js");
var Image$ReactHooksTemplate = require("./common/image.res.js");
var Filters$ReactHooksTemplate = require("./dashboard/filters/filters.res.js");
var Loading$ReactHooksTemplate = require("./dashboard/dashboard/Loading.res.js");
var Pagination$ReactHooksTemplate = require("./common/Pagination.res.js");
var PaginationUtils$ReactHooksTemplate = require("./common/PaginationUtils.res.js");

function emptyState(param) {
  return {
          header: /* [] */0,
          contents: /* [] */0
        };
}

function noMessage(param) {
  return "";
}

function decodeDownloadReport(json) {
  return Json_decode.field("file_name", Json_decode.string, json);
}

function decodeCustomerDetail(header, json) {
  return List.map((function (name) {
                return Json_decode.optional((function (param) {
                              return Json_decode.field(name, Json_decode.string, param);
                            }), json);
              }), header);
}

function decodeResponses(header, json) {
  return List.map((function (name) {
                return Json_decode.optional((function (param) {
                              return Json_decode.field(name, Json_decode.string, param);
                            }), json);
              }), header);
}

function decodeContent(header, json) {
  var responseHeaders = Json_decode.field("response_headers", (function (param) {
          return Json_decode.list(Json_decode.string, param);
        }), json);
  return {
          customerDetails: Json_decode.field("customer_details", (function (param) {
                  return decodeCustomerDetail(header, param);
                }), json),
          responseHeaders: responseHeaders,
          responses: Json_decode.field("responses", (function (param) {
                  return decodeResponses(responseHeaders, param);
                }), json)
        };
}

function decode(json) {
  var header = Json_decode.field("header", (function (param) {
          return Json_decode.list(Json_decode.string, param);
        }), json);
  return {
          header: header,
          contents: Json_decode.field("report", (function (param) {
                  return Json_decode.list((function (param) {
                                return decodeContent(header, param);
                              }), param);
                }), json)
        };
}

var Report = {
  emptyState: emptyState,
  noMessage: noMessage,
  decodeDownloadReport: decodeDownloadReport,
  decodeCustomerDetail: decodeCustomerDetail,
  decodeResponses: decodeResponses,
  decodeContent: decodeContent,
  decode: decode
};

var emptyReports = {
  header: /* [] */0,
  contents: /* [] */0
};

var initialState = {
  loading: true,
  reports: emptyReports,
  toggleFilter: false,
  selectedRow: undefined
};

function reducer(state, x) {
  if (typeof x !== "object") {
    if (x === "FetchReportsInProgress") {
      return {
              loading: true,
              reports: state.reports,
              toggleFilter: state.toggleFilter,
              selectedRow: state.selectedRow
            };
    } else {
      return {
              loading: state.loading,
              reports: state.reports,
              toggleFilter: !state.toggleFilter,
              selectedRow: state.selectedRow
            };
    }
  } else if (x.TAG === "FetchReportsCompleted") {
    return {
            loading: false,
            reports: x._0,
            toggleFilter: state.toggleFilter,
            selectedRow: state.selectedRow
          };
  } else {
    return {
            loading: state.loading,
            reports: state.reports,
            toggleFilter: state.toggleFilter,
            selectedRow: x._0
          };
  }
}

function totalRecord(x) {
  if (x !== undefined) {
    return x;
  } else {
    return "1";
  }
}

function perPage(x) {
  if (x !== undefined) {
    return x;
  } else {
    return "1";
  }
}

var emptyPageInfo = {
  total: "1",
  perPage: "1"
};

function Responses(props) {
  var match = React.useReducer(reducer, initialState);
  var dispatch = match[1];
  var state = match[0];
  var match$1 = React.useState(function (param) {
        return emptyPageInfo;
      });
  var setPageInfo = match$1[1];
  var pageInfo = match$1[0];
  var queryParams = Querystringify.parse(props.params);
  var visualizationId = Js_dict.get(queryParams, "visualization_id");
  var word = Js_dict.get(queryParams, "keyword");
  var selectedRow = function (i) {
    var x = state.selectedRow;
    if (x !== undefined) {
      return x === i;
    } else {
      return false;
    }
  };
  var x = Js_dict.get(queryParams, "page");
  var currentPage;
  if (x !== undefined && x !== "") {
    var page = Belt_Int.fromString(x);
    currentPage = page !== undefined ? page : 1;
  } else {
    currentPage = 1;
  }
  var url = "/api/v1/responses?visualization_id=" + Belt_Option.getExn(visualizationId) + "&keyword=" + Belt_Option.getWithDefault(word, "") + "&page=" + String(currentPage);
  var handlePageChange = function (pageNumber) {
    var pageNo = String(pageNumber);
    RescriptReactRouter.push("/responses?visualization_id=" + Belt_Option.getExn(visualizationId) + "&keyword=" + Belt_Option.getWithDefault(word, "") + "&page=" + pageNo);
  };
  var fetchReport = function (param) {
    return Js_promise.then_((function (param) {
                  var headers = param[0];
                  var x = headers.get("Total");
                  var total = x !== null ? (
                      x === null ? undefined : Caml_option.some(x)
                    ) : "1";
                  var x$1 = headers.get("Per-Page");
                  var perPage = x$1 !== null ? (
                      x$1 === null ? undefined : Caml_option.some(x$1)
                    ) : "1";
                  var report = Js_promise.then_((function (json) {
                          return Promise.resolve(Json_decode.field("report", decode, json));
                        }), param[1]);
                  return Promise.resolve([
                              report,
                              [
                                total,
                                perPage
                              ]
                            ]);
                }), Http$ReactHooksTemplate.fetchGetJSONWithHeader(url));
  };
  var onApplyFilter = function (param) {
    Curry._1(dispatch, "ToggleFilter");
    Curry._1(dispatch, "FetchReportsInProgress");
    Js_promise.then_((function (param) {
            var pageInfo = param[1];
            var perPage = pageInfo[1];
            var total = pageInfo[0];
            Curry._1(setPageInfo, (function (param) {
                    return {
                            total: total,
                            perPage: perPage
                          };
                  }));
            Js_promise.then_((function (report) {
                    return Promise.resolve(Curry._1(dispatch, {
                                    TAG: "FetchReportsCompleted",
                                    _0: report
                                  }));
                  }), param[0]);
            return Promise.resolve();
          }), fetchReport());
  };
  var toggleFilter = function (param) {
    Curry._1(dispatch, "ToggleFilter");
  };
  React.useEffect((function (param) {
          Curry._1(dispatch, "FetchReportsInProgress");
          Js_promise.then_((function (param) {
                  var pageInfo = param[1];
                  var perPage = pageInfo[1];
                  var total = pageInfo[0];
                  Curry._1(setPageInfo, (function (param) {
                          return {
                                  total: total,
                                  perPage: perPage
                                };
                        }));
                  Js_promise.then_((function (report) {
                          return Promise.resolve(Curry._1(dispatch, {
                                          TAG: "FetchReportsCompleted",
                                          _0: report
                                        }));
                        }), param[0]);
                  return Promise.resolve();
                }), fetchReport());
        }), [currentPage]);
  var totalCount = Caml_format.int_of_string(pageInfo.total);
  var perPageCount = Caml_format.int_of_string(pageInfo.perPage);
  var totalPagesCount = PaginationUtils$ReactHooksTemplate.totalPages(totalCount, perPageCount);
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                state.toggleFilter ? JsxRuntime.jsx(Filters$ReactHooksTemplate.make, {
                        onClose: toggleFilter,
                        onApply: onApplyFilter,
                        showDateFilter: false,
                        showFilterPills: false
                      }) : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
                state.loading ? JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsx(Loading$ReactHooksTemplate.make, {
                              text: "Loading..."
                            }),
                        className: "h-screen w-full animated fadeIn"
                      }) : JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsx("h2", {
                                        children: "Transactions",
                                        className: "text-xl font-semibold"
                                      }),
                                  JsxRuntime.jsxs("div", {
                                        children: [
                                          JsxRuntime.jsxs("button", {
                                                children: [
                                                  JsxRuntime.jsx("img", {
                                                        className: "h-14-px mr-2-px",
                                                        src: Image$ReactHooksTemplate.filterButton
                                                      }),
                                                  "Filters"
                                                ],
                                                className: "bg-ghostwhite border border-gray-400\n                shadow-inner flex rounded py-2 px-3 text-xs",
                                                id: "filters",
                                                onClick: (function (param) {
                                                    Curry._1(dispatch, "ToggleFilter");
                                                  })
                                              }),
                                          JsxRuntime.jsxs("a", {
                                                children: [
                                                  JsxRuntime.jsx("img", {
                                                        className: "h-14-px mr-1 filter-white",
                                                        src: Image$ReactHooksTemplate.download
                                                      }),
                                                  "Download"
                                                ],
                                                className: "bg-pigmentblue border border-gray-400\n                  flex rounded py-2 px-3 text-xs text-white",
                                                href: "/api/v1/responses/download?word=" + Belt_Option.getWithDefault(word, "") + "&visualization_id=" + Belt_Option.getExn(visualizationId)
                                              })
                                        ],
                                        className: "flex gap-4"
                                      })
                                ],
                                className: "flex justify-between items-center p-20-px"
                              }),
                          JsxRuntime.jsx(Pagination$ReactHooksTemplate.Bar.make, {
                                currentPage: currentPage,
                                totalPages: totalPagesCount,
                                totalRecords: totalCount,
                                perPage: perPageCount,
                                handlePageChange: handlePageChange,
                                itemLabel: "transactions",
                                className: "mx-20-px mb-4"
                              }),
                          JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsxs("table", {
                                      children: [
                                        JsxRuntime.jsx("thead", {
                                              children: JsxRuntime.jsxs("tr", {
                                                    children: [
                                                      $$Array.of_list(List.mapi((function (i, header) {
                                                                  return JsxRuntime.jsx("th", {
                                                                              children: JsxRuntime.jsxs("div", {
                                                                                    children: [
                                                                                      $$String.capitalize_ascii(header),
                                                                                      JsxRuntime.jsx("img", {
                                                                                            className: "ml-4-px",
                                                                                            src: Image$ReactHooksTemplate.heading
                                                                                          })
                                                                                    ],
                                                                                    className: "flex"
                                                                                  }),
                                                                              className: "px-4 py-2"
                                                                            }, String(i));
                                                                }), state.reports.header)),
                                                      JsxRuntime.jsx("th", {
                                                            className: "w-10"
                                                          })
                                                    ]
                                                  }),
                                              className: "font-medium p-4 bg-ghostwhite text-aurometalsaurus"
                                            }),
                                        JsxRuntime.jsx("tbody", {
                                              children: $$Array.of_list(List.mapi((function (i, x) {
                                                          return JsxRuntime.jsxs(JsxRuntime.Fragment, {
                                                                      children: [
                                                                        JsxRuntime.jsxs("tr", {
                                                                              children: [
                                                                                $$Array.of_list(List.mapi((function (k, step) {
                                                                                            if (step !== undefined) {
                                                                                              return JsxRuntime.jsx("td", {
                                                                                                          children: step,
                                                                                                          className: "px-4 py-2"
                                                                                                        }, String(k));
                                                                                            } else {
                                                                                              return JsxRuntime.jsx("td", {
                                                                                                          children: "",
                                                                                                          className: "px-4 py-2"
                                                                                                        }, String(k));
                                                                                            }
                                                                                          }), x.customerDetails)),
                                                                                JsxRuntime.jsx("td", {
                                                                                      children: selectedRow(i) ? JsxRuntime.jsx("img", {
                                                                                              className: "h-7-px",
                                                                                              src: Image$ReactHooksTemplate.chevronUp
                                                                                            }) : JsxRuntime.jsx("img", {
                                                                                              className: "h-7-px filter-gray-400",
                                                                                              src: Image$ReactHooksTemplate.chevronDown
                                                                                            }),
                                                                                      className: "px-4 py-2"
                                                                                    })
                                                                              ],
                                                                              className: "border-b border-bottom-gray-600 " + (
                                                                                selectedRow(i) ? "bg-alicebluesolid" : ""
                                                                              ),
                                                                              onClick: (function (param) {
                                                                                  if (selectedRow(i)) {
                                                                                    return Curry._1(dispatch, {
                                                                                                TAG: "SelectRow",
                                                                                                _0: undefined
                                                                                              });
                                                                                  } else {
                                                                                    return Curry._1(dispatch, {
                                                                                                TAG: "SelectRow",
                                                                                                _0: i
                                                                                              });
                                                                                  }
                                                                                })
                                                                            }, String(i)),
                                                                        selectedRow(i) ? JsxRuntime.jsx("tr", {
                                                                                children: JsxRuntime.jsx("td", {
                                                                                      children: JsxRuntime.jsxs("table", {
                                                                                            children: [
                                                                                              JsxRuntime.jsxs("thead", {
                                                                                                    children: [
                                                                                                      JsxRuntime.jsx("th", {
                                                                                                            children: JsxRuntime.jsx("p", {
                                                                                                                  children: "Question"
                                                                                                                }),
                                                                                                            className: "w-1/3 px-4 py-2"
                                                                                                          }),
                                                                                                      JsxRuntime.jsx("th", {
                                                                                                            children: JsxRuntime.jsx("p", {
                                                                                                                  children: "Answer"
                                                                                                                }),
                                                                                                            className: "w-2/3 px-4 py-2"
                                                                                                          })
                                                                                                    ],
                                                                                                    className: "font-medium p-4 bg-ghostwhite text-aurometalsaurus"
                                                                                                  }),
                                                                                              JsxRuntime.jsx("tbody", {
                                                                                                    children: $$Array.of_list(List.mapi((function (i, h) {
                                                                                                                return JsxRuntime.jsxs("tr", {
                                                                                                                            children: [
                                                                                                                              JsxRuntime.jsx("td", {
                                                                                                                                    children: JsxRuntime.jsx("p", {
                                                                                                                                          children: h
                                                                                                                                        }),
                                                                                                                                    className: "w-1/3 px-4 py-2"
                                                                                                                                  }, String(i)),
                                                                                                                              JsxRuntime.jsx("td", {
                                                                                                                                    children: JsxRuntime.jsx("p", {
                                                                                                                                          children: Belt_Option.getWithDefault(Caml_array.get(Belt_List.toArray(x.responses), i), "")
                                                                                                                                        }),
                                                                                                                                    className: "w-2/3 px-4 py-2"
                                                                                                                                  })
                                                                                                                            ],
                                                                                                                            className: "border-b border-gray-200 w-full"
                                                                                                                          });
                                                                                                              }), x.responseHeaders)),
                                                                                                    className: "border-b border-bottom-gray-600"
                                                                                                  })
                                                                                            ],
                                                                                            className: "text-left table-auto w-full border-separate text-xs font-medium"
                                                                                          }),
                                                                                      className: "px-20 py-10",
                                                                                      colSpan: 8
                                                                                    }),
                                                                                className: "border-b border-gray-200 w-full"
                                                                              }) : JsxRuntime.jsx(JsxRuntime.Fragment, {})
                                                                      ]
                                                                    });
                                                        }), state.reports.contents))
                                            })
                                      ],
                                      className: "text-left table-auto w-full border-separate text-xs font-medium"
                                    }),
                                className: "flex px-20-px"
                              })
                        ]
                      })
              ]
            });
}

var noMessage$1 = "";

var make = Responses;

exports.Report = Report;
exports.emptyReports = emptyReports;
exports.initialState = initialState;
exports.reducer = reducer;
exports.totalRecord = totalRecord;
exports.perPage = perPage;
exports.emptyPageInfo = emptyPageInfo;
exports.noMessage = noMessage$1;
exports.make = make;
/* react Not a pure module */
